<template>
  <div>
    <div class="p-5 my-5">
      <el-row :gutter="20">
        <el-col :lg="24" :xl="24" style="margin-top: 40px">
          <el-row :gutter="20" class="flex-row">
            <!-- Recent Release 列，始终在左边 -->
            <el-col :lg="11" :xl="12" style="order: 1">
              <recent-release></recent-release>
            </el-col>
            <!-- T2T-Hub Overview 列，始终在右边 -->
            <el-col :lg="13" :xl="12" style="order: 2">
              <div class="hb-jumbotron">
                <b-jumbotron header-tag="h4" header-level="4">
                  <template #header>
                    <h4 style="font-size: 2rem; font-weight: 600">
                      T2T-Hub overview
                    </h4>
                  </template>
                  <!-- <template #lead> Last update: 2024-12-29 </template> -->
                  <data-portal></data-portal>
                </b-jumbotron>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <!-- 增加下划线 -->

        <div>
          <h4 style="color: #555; padding-left: 2rem">Tools</h4>
          <home-tools></home-tools>
        </div>

        <!-- T2T Genome Static -->
        <el-col :lg="24" :xl="24">
          <h4 style="color: #555; padding-left: 2rem">Genome release date</h4>
          <chart-view
            ref="homeScatter"
            :chartOption="scatterOptions"
          ></chart-view>

          <el-divider></el-divider>
        </el-col>

        <!-- T2T Genome Tree and Information -->
        <div
          class="tree-control d-flex align-items-center justify-content-between"
          style="padding: 0 2rem; margin-bottom: 1rem"
        >
          <!-- 左侧标题 -->
          <h3 style="color: #555; margin: 0">Genome Tree and Information</h3>

          <!-- 右侧控件：Switch + Buttons -->
          <div class="d-flex align-items-center">
            <!-- Show tree length Switch -->
            <el-switch
              v-model="showLength"
              active-text="Show tree length"
              inactive-color="#ff4949"
              active-color="#13ce66"
              @change="updateTreeWidth"
              style="margin-right: 15px"
            ></el-switch>

            <!-- Full-length Switch -->
            <el-switch
              active-text="Full table length"
              v-model="tableFullLength"
              style="margin-right: 15px"
            ></el-switch>

            <!-- Plant / Animal Buttons -->
            <el-button
              type="success"
              :plain="filterType !== 'plant'"
              @click="filterSpecies('plant')"
              style="margin-right: 10px"
              >🌱 Plant</el-button
            >

            <el-button
              type="primary"
              :plain="filterType !== 'animal'"
              @click="filterSpecies('animal')"
              >🐵 Animal</el-button
            >
          </div>
        </div>
        <!-- <el-tree :data="this.tree1" :props="treeProps" @node-click="handleNodeClick" :highlight-current="true" :default-expand-all="true"></el-tree> -->
        <div
          v-show="filterType === 'plant'"
          class="row mt-3 mr-1"
          :style="{ maxHeight: tableFullLength ? '5000rem' : '600px' }"
          style="
            overflow: auto;
            position: relative;
            display: flex;
            flex-wrap: nowrap;
          "
          ref="outerContainer"
        >
          <el-col :lg="10" :xl="10" class="mb-5">
            <div
              id="ortho-tree-display"
              class="mx-3"
              style="position: relative; margin-top: 40px"
            ></div>
          </el-col>
          <el-col :lg="14" :xl="14" class="mb-5">
            <el-row>
              <el-table
                highlight-current-row
                ref="table"
                :data="filterdata"
                stripe
                style="position: relative; width: 100%"
                :row-style="{ height: '40px' }"
                :header-row-style="{
                  height: '40px',
                  fontSize: '18px',
                  color: '#2ca25f',
                }"
                :cell-style="{ padding: '0px' }"
                :header-cell-style="{ padding: '0px' }"
              >
                <el-table-column
                  prop="name"
                  label="Latin Name"
                  min-width="200"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span style="font-style: italic">
                      <a :href="'/t2thub/genome/' + scope.row.full_name">
                        {{ scope.row.name.replace("_", " ") }}
                      </a>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="common_name"
                  label="Common Name"
                  min-width="160"
                  show-overflow-tooltip
                  align="left"
                />
                <el-table-column
                  prop="Chr"
                  label="Chr"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="T2T"
                  label="T2T"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="T2N"
                  label="T2N"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="N2N"
                  label="N2N"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="Size"
                  label="Size (Mb)"
                  min-width="100"
                  align="center"
                />
                <el-table-column
                  prop="Gene"
                  label="Gene"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Gene.toString().replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      )
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="BUSCO"
                  label="BUSCO"
                  min-width="100"
                  align="center"
                />
                <el-table-column
                  prop="PMID"
                  label="PMID"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <a
                      :href="
                        'https://pubmed.ncbi.nlm.nih.gov/' + scope.row.PMID
                      "
                      target="_blank"
                      class="link-style"
                    >
                      {{ scope.row.PMID }}
                    </a>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-col>
        </div>
        <div
          v-show="filterType === 'animal'"
          class="row mt-3 mr-1"
          :style="{ maxHeight: tableFullLength ? '5000rem' : '600px' }"
          style="
            overflow: auto;
            position: relative;
            display: flex;
            flex-wrap: nowrap;
          "
          ref="outerContainer_animal"
        >
          <el-col :lg="10" :xl="10" class="mb-5">
            <div
              id="ortho-tree-display-animal"
              class="mx-3"
              style="position: relative; margin-top: 40px"
            ></div>
          </el-col>
          <el-col :lg="14" :xl="14" class="mb-5">
            <el-row>
              <el-table
                highlight-current-row
                ref="table"
                :data="animal_filterdata"
                stripe
                style="position: relative; width: 100%"
                :row-style="{ height: '40px' }"
                :header-row-style="{
                  height: '40px',
                  fontSize: '18px',
                  color: '#2ca25f',
                }"
                :cell-style="{ padding: '0px' }"
                :header-cell-style="{ padding: '0px' }"
              >
                <el-table-column
                  prop="name"
                  label="Latin Name"
                  min-width="200"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span style="font-style: italic">
                      <a :href="'/t2thub/genome/' + scope.row.full_name">
                        {{ scope.row.name.replace("_", " ") }}
                      </a>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="common_name"
                  label="Common Name"
                  min-width="160"
                  show-overflow-tooltip
                  align="left"
                />
                <el-table-column
                  prop="Chr"
                  label="Chr"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="T2T"
                  label="T2T"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="T2N"
                  label="T2N"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="N2N"
                  label="N2N"
                  min-width="60"
                  align="center"
                />
                <el-table-column
                  prop="Size"
                  label="Size (Mb)"
                  min-width="100"
                  align="center"
                />
                <el-table-column
                  prop="Gene"
                  label="Gene"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.Gene.toString().replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      )
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="BUSCO"
                  label="BUSCO"
                  min-width="100"
                  align="center"
                />
                <el-table-column
                  prop="PMID"
                  label="PMID"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <a
                      :href="
                        'https://pubmed.ncbi.nlm.nih.gov/' + scope.row.PMID
                      "
                      target="_blank"
                      class="link-style"
                    >
                      {{ scope.row.PMID }}
                    </a>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-col>
        </div>
        <el-divider></el-divider>

        <!-- T2T Genome Taxonomy -->
        <el-col :lg="24" :xl="24" style="margin-top: 10px">
          <h4 style="color: #555; padding-left: 2rem">Genome Taxonomy</h4>
          <el-col :span="6" class="chart-container">
            <div class="chart-header">
              <span class="chart-title">Phylum</span>
            </div>
            <chart-view :chartOption="pieoption" ref="hbTreeChart"></chart-view>
          </el-col>
          <el-col :span="6" class="chart-container">
            <div class="chart-header">
              <span class="chart-title">Class</span>
            </div>
            <chart-view
              :chartOption="pieoption1"
              ref="hbTreeChart1"
            ></chart-view>
          </el-col>
          <el-col :span="6" class="chart-container">
            <div class="chart-header">
              <span class="chart-title">Order</span>
            </div>
            <chart-view
              :chartOption="pieoption2"
              ref="hbTreeChart2"
            ></chart-view>
          </el-col>
          <el-col :span="6" class="chart-container">
            <div class="chart-header">
              <span class="chart-title">Family</span>
            </div>
            <chart-view
              :chartOption="pieoption3"
              ref="hbTreeChart3"
            ></chart-view>
          </el-col>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 10px">
        <!-- 2. Citation -->
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="18">
          <div class="info-card">
            <div class="card-title">Citation</div>

            <div class="card-content" style="line-height: 1.8">
              Haoyu Chao<sup>#</sup>,
              Zhonghao Ruan<sup>#</sup>,
              Zhuojin Li<sup>#</sup>, Xinkai Zhou, Shilong Zhang,
              Xingxing Shen, Cong Feng*, Dijun Chen*, Ming Chen*,
              T2T-Hub: a central platform for analyzing plant and animal
              telomere-to-telomere genomes, 
              <strong><i>Nucleic Acids Research</i></strong>, 2026, gkag423. DOI:
              <a
                href="https://doi.org/10.1093/nar/gkag423"
                target="_blank"
                style="color: #409eff"
              >
              https://doi.org/10.1093/nar/gkag423</a>,

              PMID:
              <a
                href="https://pubmed.ncbi.nlm.nih.gov/42087564/"
                target="_blank"
                style="color: #409eff"
              >
                42087564</a>.
            </div>
          </div>
        </el-col>

        <!-- 3. Open Access Policy -->
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="6">
          <div class="info-card">
            <div class="card-title">Open Access Policy</div>

            <div class="card-content" style="text-align: left">
              T2T-Hub website is free and open to all users with no login
              requirement. All data and results are freely available under the
              <a
                href="https://creativecommons.org/licenses/by-sa/4.0/"
                target="_blank"
                style="color: #409eff"
              >
              CC BY-SA 4.0
              </a>
               license.

              <a
                href="https://biobigdata.nju.edu.cn/t2thub_help/2.3.result.html"
                target="_blank"
                style="color: #409eff"
              >
                See more</a>.
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as phylotree from "phylotree";
import doughnut from "@/components/echarts/options/pie/doughnut";
import "phylotree/dist/phylotree.css";
import * as d3 from "d3";
// import * as d3 from 'd3'
import "../../../../node_modules/element-tree-line/dist/style.scss";
// import 'element-tree-line/dist/style.scss';
// import ChartView from '@/components/echarts/main.vue'
// import ployTree from '@/components/d3/polyTree.vue'
import treeRadial from "@/components/echarts/options/tree/treeRadial";
import stackBar from "@/components/echarts/options/bar/stackBar";
import DataPortal from "../components/DataPortal";
import RecentRelease from "../components/RecentRelease";
import HomeTools from "./HomeTools.vue";
//import { getChartInfo } from '@/api/api';
import treeData from "@/assets/json/busco_tree_named.json";

import { getgenomestatic } from "@/api/api";
import ChartView from "@/components/echarts/main.vue";
import homeScatter from "@/components/echarts/options/scatter/homeScatter";
import { gethomeclassify, gethometable } from "@/api/api";

// import speciestree from '../../../../speciestree.nwk';

export default {
  components: { DataPortal, RecentRelease, ChartView, HomeTools },
  // components: { ChartView, DataPortal, ployTree, RecentRelease },
  data() {
    return {
      showLength: true,
      homolog: "",
      pieoption: {},
      pieoption1: {},
      pieoption2: {},
      pieoption3: {},
      Showall1: "Show All",
      Showall2: "Show All",
      filterTexttree1: "",
      filterTexttree2: "",
      showall1: false,
      showall2: false,
      treeProps: {
        id: "id",
        children: "children",
        label: "label",
        showLabelLine: true,
        indent: 16,
      },
      treeOption: {},
      chartContainerSize: 0,
      polyWidth: 0,
      hbsearch: null,
      isActivatedFlag: false,
      showPoly: false,
      barData: {
        x: [2000, 2001, 2002, 2003, 2004, 2005, 2006],
        series: [
          {
            name: "Direct",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            data: [320, 332, 301, 334, 390, 330, 320],
          },
          {
            name: "Email",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "Union Ads",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [220, 182, 191, 234, 290, 330, 310],
          },
          {
            name: "Video Ads",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [150, 232, 201, 154, 190, 330, 410],
          },
          {
            name: "Search Engine",
            type: "bar",
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            emphasis: {
              focus: "series",
            },
          },
        ],
      },
      newTree: treeData,
      filtertree: "",
      filtertree_animal: "",
      width: 1000,
      treeColor: "Category10",
      tableFullLength: false,
      static: "",
      scatterOptions: {},
      ploidyData: {},
      defaultColor:
        "#e5f5e0;#c7e9c0;#a1d99b;#74c476;#41ab5d;#238b45;#006d2c;#00441b",
      filterdata: [],
      animal_filterdata: [],
      filterType: "plant",

      // speciestree:speciestree
    };
  },
  watch: {
    filterTexttree1(val) {
      this.$refs.tree1.filter(val);
    },
    filterTexttree2(val) {
      this.$refs.tree2.filter(val);
    },
  },
  created() {
    this.resizeContainer();
    this.treeOption = treeRadial(this.newTree.children);
    this.barOption = stackBar(this.barData);
    this.updateTreeWidth();
    this.getstatic();
    gethometable().then((response) => {
      this.filterdata = response.data["genometreeinfo"];
      this.animal_filterdata = response.data["animal_genometreeinfo"];
      // console.log(response.data);
    });
    gethomeclassify().then((response) => {
      this.homolog = response.data;
      // console.log(this.homolog);
      this.pieoption = doughnut(
        this.homolog.Phylum.filter((item) => item.value !== 0)
      );
      this.pieoption1 = doughnut(
        this.homolog.Class.filter((item) => item.value !== 0)
      );
      this.pieoption2 = doughnut(
        this.homolog.Roder.filter((item) => item.value !== 0)
      );
      this.pieoption3 = doughnut(
        this.homolog.Family.filter((item) => item.value !== 0)
      );
      this.$refs.hbTreeChart.myChart.setOption(this.pieoption);
      this.$refs.hbTreeChart1.myChart.setOption(this.pieoption1);
      this.$refs.hbTreeChart2.myChart.setOption(this.pieoption2);
      this.$refs.hbTreeChart3.myChart.setOption(this.pieoption3);
    });
  },
  activated() {
    this.isActivatedFlag = true;
    this.resizeContainer();
    // this.$refs.hbTreeChart.resizeHandler();
  },
  deactivated() {
    this.isActivatedFlag = false;
  },
  mounted() {
    window.addEventListener("resize", () => {
      setTimeout(this.resizeContainer(), 100);
    });
    this.updateTreeWidth();
    // add click redirect event for tree diagram.
    // this.mountClick()
    // Initing browser -> resize height
    // When window's size changes, changes container's height -> auto resize
    // Cause myChart mounted resizeHandler, it doesn't need resize any more (window.addEventListener('resize', this.resizeHandler))
    setTimeout((this.showPoly = true), 1000);
  },
  methods: {
    filterSpecies(type) {
      this.filterType = type;
    },
    getstatic() {
      getgenomestatic().then((response) => {
        this.static = response.data;
        this.groupDataByPloidy();
        this.scatterOptions = homeScatter(
          this.ploidyData["2x"],
          this.ploidyData["3x"],
          this.ploidyData["4x"],
          this.ploidyData["6x"],
          this.ploidyData["8x"]
        );
        // console.log(this.static)
      });
    },
    groupDataByPloidy() {
      this.static.forEach((item) => {
        if (!this.ploidyData[item.ploidy]) {
          this.ploidyData[item.ploidy] = [];
        }
        this.ploidyData[item.ploidy].push([
          item.date,
          parseFloat(item.length), // Convert length to number
          item.rate,
          item.full_name,
          item.speciesType,
        ]);
      });
       console.log(this.ploidyData)
    },
    updateTreeWidth() {
      this.filtertree =
        "((Chlamydomonas_reinhardtii:1,(Chlorella_pyrenoidosa_DBH:1,Chlorella_sorokiniana_NS4-2:1)1:4.02545)1:1.8095,((Physcomitrium_patens:1,Syntrichia_caninervis:1)1:4.57857,(((((((((Hygroryza_aristata_Hap2:1,Hygroryza_aristata_Hap1:1)1:6.79554,((((((Oryza_sativa_J4155S:1,Oryza_sativa_XL628S:1)1:0.131652,Oryza_sativa_LK638S:1)1:0.128684,Oryza_sativa_HuaZhan:1)1:0.24211,((Oryza_sativa_MH63RS3:1,Oryza_sativa_MH63KL1:1)1:0.325399,Oryza_sativa_ZS97RS3:1)1:0.075666)1:0.175544,Oryza_sativa_9311:1)1:0.395267,(Oryza_rufipogon_Y476:1,Oryza_sativa_NIP:1)1:0.035198)1:4.77524)1:2.4803,(Triticum_aestivum_CS-IAAS:1,(Avena_sativa_Marvellous:1,Beckmannia_syzigachne:1)1:1.61892)1:4.05382)1:0.267538,((((((Sorghum_bicolor_Ji2055:1,Sorghum_bicolor_BTx623:1)1:0.580659,((Sorghum_bicolor_CHBZ:1,((Sorghum_bicolor_Huandiaonuo:1,Sorghum_bicolor_Hongyingzi:1)1:0.077671,Sorghum_bicolor_654:1)1:0.053299)1:0.310927,Sorghum_bicolor_E048:1)1:0.112364)1:4.24564,Erianthus_rufipilus:1)1:1.04999,Zea_mays_Mo17:1)1:2.96205,((Panicum_miliaceum_AJ8:1,(Setaria_italica_Yugu1:1,Cenchrus_fungigraminus:1)1:2.17427)1:0.292718,Echinochloa_phyllopogon:1)1:1.35085)1:1.82894,(Phragmites_australis:1,Phragmites_australis_Cuiplus:1)1:4.67572)1:2.12893)1:4.59848,Eleocharis_dulcis:1)1:0.479239,(Ananas_comosus:1,Typha_latifolia:1)1:0.613865)1:0.525743,((((Musa_acuminata_malaccensis_Hap2:1,Musa_acuminata_malaccensis_Hap1:1)1:1.12022,Musa_acuminata_DH-Pahang:1)1:0.136649,(Musa_acuminata_Baxijiao_Hap3:1,(Musa_acuminata_Baxijiao_Hap1:1,Musa_acuminata_Baxijiao_Hap2:1)1:0.086402)1:0.091434)1:4.67826,Thalia_dealbata:1)1:3.04326)1:2.4519,Persea_americana_Mill:1)1:0.246957,(((Dianthus_caryophyllus_Hap2:1,Dianthus_caryophyllus_Hap1:1)1:6.52356,(Fallopia_multiflora_AYY:1,Fallopia_multiflora_CYY:1)1:6.01686)1:1.45282,((((((((((((Solanum_commersonii_Hap2:1,Solanum_commersonii_Hap1:1)1:2.0005,Solanum_tuberosum:1)1:1.13652,(Solanum_lycopersicum_M82:1,Solanum_lycopersicum_Micro-Tom:1)1:4.56504)1:2.81297,Solanum_melongena_NO211:1)1:1.1779,((((((Capsicum_annuum_PM1533:1,Capsicum_annuum_Ac1979:1)1:0.635843,(Capsicum_annuum_Zunla-1:1,Capsicum_annuum_Qiemen:1)1:0.089731)1:0.360473,Capsicum_annuum:1)1:0.867658,(Capsicum_frutescens_CA254:1,Capsicum_chinense_PBC932:1)1:0.201164)1:0.646371,(Capsicum_eximium_CA259:1,Capsicum_baccatum_CA272:1)1:0.534784)1:4.02868,(Capsicum_rhomboideum:1,Capsicum_rhomboideum_CA352:1)1:2.34646)1:1.8975)1:2.18437,(Nicotiana_tomentosiformis:1,(Nicotiana_sylvestris:1,Nicotiana_benthamiana:1)1:0.828544)1:3.36453)1:4.52276,Ipomoea_batatas_Xiaoshu:1)1:1.51618,(Uncaria_rhynchophylla:1,Oldenlandia_diffusa:1)1:2.76898)1:0.049948,((((Olea_europaea_Leccino:1,Ligustrum_lucidum:1)1:1.77868,Forsythia_suspensa_CHAU:1)1:0.312039,Jasminum_sambac:1)1:3.46803,Scutellaria_baicalensis:1)1:1.75707)1:1.54326,(((((Daucus_carota_Kurodagosun:1,Daucus_carota_DH13M14:1)1:4.40233,Peucedanum_praeruptorum:1)1:5.01294,Centella_asiatica:1)1:0.316008,Panax_ginseng:1)1:3.0434,Lactuca_sativa_PKU06:1)1:0.410557)1:0.529981,((((Rhododendron_liliiflorum:1,Rhododendron_molle:1)1:0.049578,(Rhododendron_vialii_Hap2:1,Rhododendron_vialii_Hap1:1)1:2.85105)1:2.97539,Vaccinium_duclouxii:1)1:3.63857,(((Actinidia_chinensis_Hongyang_Hap2:1,Actinidia_chinensis_Donghong:1)1:0.050685,Actinidia_chinensis_Hongyang_Hap1:1)1:1.77509,Actinidia_latifolia_Kuoye:1)1:4.75152)1:2.6389)1:1.12989,((((((((((Rosa_hybrida_Samantha:1,Rosa_rugosa:1)1:2.87298,((Fragaria_vesca_Hawaii4:1,Fragaria_x_ananassa_Benihoppe:1)1:0.589198,Fragaria_iinumae:1)1:3.60331)1:4.43422,((Cerasus_speciosa_IZO01:1,Prunus_persica_ZSH:1)1:4.11123,(((((((Pyrus_pyrifolia_Yuluxiang_Hap2:1,Pyrus_pyrifolia_Hongxiangsu_Hap2:1)1:0.675353,Pyrus_bretschneideri_DS:1)1:0.04401,Pyrus_pyrifolia_YunhongNO1:1)1:0.087832,(Pyrus_pyrifolia_Hongxiangsu_Hap1:1,Pyrus_pyrifolia_Yuluxiang_Hap1:1)1:0.35494)1:0.439853,Pyrus_communis_KFL:1)1:1.80495,(Malus_niedzwetzkyana:1,((Malus_domestica_Fuji_Hap1:1,Malus_domestica_Fuji_Hap2:1)1:0.096567,(Malus_domestica_Hap1:1,Malus_domestica_Hap2:1)1:0.259396)1:0.153157)1:2.34292)1:0.150644,Chaenomeles_speciosa:1)1:4.48762)1:1.80691)1:3.15193,((Ficus_hispida:1,Morus_notabilis:1)1:4.15312,((Ziziphus_mauritiana_MISI:1,Ziziphus_mauritiana_XSYS:1)1:3.62538,((Ziziphus_jujuba_Junzao:1,Ziziphus_jujuba_Suanzao:1)1:0.475576,Ziziphus_jujuba_Dongzao:1)1:2.96556)1:5.24654)1:0.920518)1:0.976329,((Juglans_sigillata:1,Myrica_rubra_Zaojia:1)1:1.36125,(Quercus_variabilis_Hap1:1,Quercus_variabilis_Hap2:1)1:6.17126)1:2.46215)1:0.126446,((((((((Cucumis_melo_821_Hap2:1,Cucumis_melo_821_Hap1:1)1:0.425025,Cucumis_melo_Kuizilikjiz:1)1:0.240883,Cucumis_melo_PI511890:1)1:2.82932,Cucumis_sativus_CLv4:1)1:3.0855,(((((Citrullus_colocynthis_PI525081:1,Citrullus_colocynthis_PI632755:1)1:1.36837,Citrullus_colocynthis_PI537300:1)1:0.056997,Citrullus_colocynthis_PI652554:1)1:0.936773,((((((Citrullus_amarus_RCAT055816:1,Citrullus_amarus_PI482276:1)1:0.045915,Citrullus_amarus_PI189225:1)1:0.102528,(Citrullus_amarus_PI296341FR:1,Citrullus_amarus_PI271769:1)1:0.109996)1:1.38121,((((((((Citrullus_lanatus_HeiShanRen:1,Citrullus_lanatus_PI381740:1)1:0.015259,((Citrullus_lanatus_CharlestonGray:1,Citrullus_lanatus_CalhounGray:1)1:0.198082,((Citrullus_lanatus_ShiHongNo2:1,Citrullus_lanatus_Sugarlee:1)1:0.006167,Citrullus_lanatus_Allsugar:1)1:0.017692)1:0.145642)1:0.037207,Citrullus_lanatus_G42:1)1:0.024104,(Citrullus_lanatus_DaBanHongZiGua:1,Citrullus_lanatus_SanBaiGua:1)1:0.063021)1:0.117924,Citrullus_lanatus_PI288522:1)1:0.051909,Citrullus_lanatus_PI254622:1)1:0.04437,Citrullus_lanatus_PKR6:1)1:0.053399,(Citrullus_mucosospermus_PI595203:1,Citrullus_mucosospermus_PI532732:1)1:0.182015)1:1.61435)1:0.519339,Citrullus_ecirrhosus_PI673135:1)1:0.074461,Citrullus_rehmii_PI670011:1)1:0.126696)1:1.35559,(Citrullus_naudinianus_PI596694F:1,Citrullus_naudinianus_PI596694M:1)1:2.59234)1:2.27575)1:1.68209,Cucurbita_maxima:1)1:1.52404,Momordica_charantia:1)1:2.28582,Gynostemma_pentaphyllum:1)1:4.03644)1:0.076267,(((((((Glycine_max_Leea3:1,Glycine_max_Wm82a5:1)1:0.526381,((Glycine_max_ZH13:1,Glycine_max_Yundou1:1)1:0.074983,Glycine_max_Wm82:1)1:0.239873)1:0.167546,Glycine_max_Jack:1)1:0.233062,Glycine_soja_yesheng71:1)1:5.31299,(Phaseolus_vulgaris_PJY4:1,(Vigna_unguiculata_Fengchan6:1,Vigna_radiata_Weilv-9:1)1:1.88985)1:3.30341)1:2.71827,Sesbania_cannabina:1)1:0.90496,(Arachis_monticola:1,Arachis_hypogaea_YZ9102:1)1:5.76328)1:3.85773)1:0.363371,((((Mangifera_indica:1,(((Citrus_limon_Hap1:1,(Citrus_reticulata_Chachi:1,(Citrus_sinensis_Valencia_Hap1:1,Citrus_aurantium_ZGSC_Hap1:1)1:0.110748)1:0.415378)1:0.169716,(Citrus_aurantium_ZGSC_Hap2:1,Citrus_sinensis_Valencia_Hap2:1)1:0.468923)1:0.225233,Citrus_limon_Hap2:1)1:5.55545)1:1.9733,(((Gossypium_hirsutum_ZM113:1,Gossypium_hirsutum_TM-1:1)1:2.12013,Gossypium_raimondii_D5-3:1)1:5.25864,Firmiana_kwangsiensis:1)1:4.46788)1:0.226748,((Manihot_esculenta_Hap1:1,Manihot_esculenta_Hap2:1)1:6.43704,((Populus_tremula_x_Populus_alba_84K_Hap2:1,Populus_tremula_x_Populus_alba_717_Hap1:1)1:0.22111,(Populus_tremula_x_Populus_alba_717_Hap2:1,Populus_tremula_x_Populus_alba_84K_Hap1:1)1:0.819703)1:5.28713)1:1.83176)1:0.383599,(((Brassica_juncea_PM:1,((Brassica_rapa_purpuraria:1,Brassica_rapa_chinensis:1)1:0.139285,Brassica_rapa_chiifu:1)1:0.125066)1:0.04915,Brassica_napus_Xiang5A:1)1:4.30825,((((Arabidopsis_thaliana_Col-PEK:1,Arabidopsis_thaliana_Col-XJTU:1)1:2.9872,Arabidopsis_thaliana_Col-CEN:1)1:7.3302,Capsella_bursa-pastoris:1)1:1.13284,Armoracia_rusticana:1)1:0.887205)1:5.67415)1:0.128327)1:0.05929,((Eucalyptus_regnans_Hap2:1,Eucalyptus_regnans_Hap1:1)1:4.7619,Rhodomyrtus_tomentosa_LFSTJN1:1)1:4.81703)1:0.488818,(((Vitis_davidii_Hap1:1,Vitis_davidii_Hap2:1)1:1.44573,(Vitis_retordii_WG_Hap2:1,Vitis_retordii_WG_Hap1:1)1:1.57768)1:0.098827,((((((Vitis_labrusca_x_Vitis_vinifera_SM_Hap1:1,Vitis_vinifera_MH_Hap1:1)1:0.052672,(Vitis_vinifera_MH_Hap2:1,Vitis_labrusca_x_Vitis_vinifera_SM_Hap2:1)1:0.038053)1:0.013009,(((Vitis_vinifera_MF_Hap1:1,(Vitis_vinifera_TS_Hap1:1,Vitis_vinifera_BM_Hap2:1)1:0.244952)1:0.00823,(Vitis_vinifera_TS_Hap2:1,Vitis_vinifera_BM_Hap1:1)1:0.115771)1:0.037973,(((Vitis_vinifera_BMNG_Hap2:1,Vitis_vinifera_HMNG_Hap2:1)1:0.288699,(Vitis_vinifera_HMNG_Hap1:1,Vitis_vinifera_BMNG_Hap1:1)1:0.300779)1:0.109886,Vitis_vinifera_MF_Hap2:1)1:0.021203)1:0.101457)1:0.106682,Vitis_vinifera_Thompson:1)1:0.069489,(((Vitis_vinifera_Yan73_Hap1:1,Vitis_vinifera_Yan73_Hap2:1)1:0.029143,(Vitis_vinifera_PN_Hap1:1,Vitis_vinifera_PN40024:1)1:0.233306)1:0.02304,Vitis_vinifera_PN_Hap2:1)1:0.070027)1:0.090676,(Vitis_vinifera_Chardonnay_Hap1:1,Vitis_vinifera_Chardonnay_Hap2:2)1:0.162141)1:0.422329)1:5.75164)1:0.22931)1:0.263515)1:1.002)1:2.39847)1:1.8095);";
      this.filtertree_animal =
        "((Bombyx_mori_KA:5e-09,(Bombyx_mori_L:0.0232796,Bombyx_mori_M:5e-09)0.781:0.000864327)1:0.568531,(Amynthas_aspergillum:0.980962,((((Neosalanx_taihuensis:0.0250497,Protosalanx_chinensis:0.0130144)1:0.22528,(Choerodon_schoenleinii:0.135265,(Acanthopagrus_schlegelii:0.0901912,Lateolabrax_maculatus:0.0949177)1:0.0220706)1:0.180406)1:0.1074,(Coilia_nasus:0.31137,((Triplophysa_yaopeizhii:0.15668,Rhinogobio_nasutus:0.105244)1:0.141482,(Electrophorus_electricus:0.181723,(Pristella_maxillaris:0.21766,(Kryptopterus_vitreolus:0.138575,(Clarias_gariepinus:0.0991217,Euchiloglanis_kishinouyei:0.122331)0.944:0.0140628)1:0.138915)1:0.0359119)1:0.067031)1:0.0985285)1:0.0785537)1:0.29219,((Anser_cygnoides:0.0876306,Gallus_gallus_Huxu:0.114731)1:0.335304,(Mus_musculus:0.217084,((Neogale_vison:0.107363,(((Neophocaena_asiaeorientalis_EFP:0.000613947,Neophocaena_asiaeorientalis_YFP:0.000765896)1:0.0692382,(Bos_taurus_Mongolia:0.0269407,(Ostfriesisches_milchschaf:0.00394289,Ovis_aries:0.00813352)1:0.0240125)1:0.0702407)1:0.0154519,(Sus_scrofa_JH:0.0174587,(Sus_scrofa_RC:0.0048741,Sus_scrofa_Min:0.0023861)1:0.00721939)1:0.084486)1:0.0330782)1:0.0317596,(Macaca_fascicularis_MFA8:0.0291585,(((Pongo_abelii:0.00164344,Pongo_pygmaeus:0.00182965)1:0.0141606,(Gorilla_gorilla:0.0079262,((Pan_troglodytes:0.0023261,Pan_paniscus:0.00207762)1:0.00429785,(Homo_sapiens_Han1:0.00363801,(Homo_sapiens_CHM13:0.000421482,Homo_sapiens_Yao:0.0209435)0.872:0.000244996)1:0.00791821)1:0.00353975)1:0.00949357)1:0.00233013,Symphalangus_syndactylus:0.02011)1:0.0101894)1:0.0878051)0.998:0.0467609)1:0.355642)1:0.297438)1:0.404541)1:0.568531);";
      const regex = /:[0-9eE.+-]+/g;
      // console.log(this.filtertree);
      this.filtertree = this.showLength
        ? this.filtertree
        : this.filtertree.replace(regex, ":1");
      this.filtertree_animal = this.showLength
        ? this.filtertree_animal
        : this.filtertree_animal.replace(regex, ":1");
      const height = 40 * 230;
      const animal_height = 40 * 39;
      let color_scale = d3.scaleOrdinal(d3["scheme" + this.treeColor]);
      let getSpecies = (node) => {
        try {
          const parts = node.data.name.split(".");
          return parts.slice(parts.length - 2).join(".");
        } catch (err) {
          console.log("nodes");
        }
        return null;
      };
      let colorNodesBySpecies = (element, data, mark = this.transID) => {
        element.style("fill", color_scale(getSpecies(data)));
        const nodeName = data.data.name.split("_");
        if (nodeName[nodeName.length - 1] === mark) {
          element.style("font-weight", 600);
          element.style("stroke", color_scale(getSpecies(data)));
          element.style("stroke-width", 1.125);
        }
      };
      // const width = this.polyWidth*0.5;
      const width = document.documentElement.clientWidth * 0.5;
      let tree = new phylotree.phylotree(this.filtertree);
      let animal_tree = new phylotree.phylotree(this.filtertree_animal);
      let renderedTree = tree.render({
        container: "#ortho-tree-display",
        height: height,
        width: width,
        "node-styler": colorNodesBySpecies,
        "left-right-spacing": "fit-to-size",
        "top-bottom-spacing": "fit-to-size",
        // "font-size": 50,
        selectable: true,
        hide: false,
        reroot: false,
        collapsible: false,
        "draw-size-bubbles": false,
        "show-scale": false,
        "align-tips": true,
      });
      let animal_renderedTree = animal_tree.render({
        container: "#ortho-tree-display-animal",
        height: animal_height,
        width: width,
        "node-styler": colorNodesBySpecies,
        "left-right-spacing": "fit-to-size",
        "top-bottom-spacing": "fit-to-size",
        // "font-size": 50,
        selectable: true,
        hide: false,
        reroot: false,
        collapsible: false,
        "draw-size-bubbles": false,
        "show-scale": false,
        "align-tips": true,
      });
      // console.log(renderedTree);
      setTimeout(() => {
        let anchor = document.getElementById("ortho-tree-display");
        let animal_anchor = document.getElementById(
          "ortho-tree-display-animal"
        );
        let animal_childnodes = animal_anchor.childNodes;
        if (animal_childnodes.length !== 0) {
          for (var i = 0; i < animal_childnodes.length; i++) {
            animal_anchor.removeChild(animal_childnodes[i]);
          }
          animal_anchor.appendChild(animal_renderedTree.show());
        } else {
          animal_anchor.appendChild(animal_renderedTree.show());
        }
        let childnodes = anchor.childNodes;
        if (childnodes.length !== 0) {
          for (var i = 0; i < childnodes.length; i++) {
            anchor.removeChild(childnodes[i]);
          }
          anchor.appendChild(renderedTree.show());
        } else {
          anchor.appendChild(renderedTree.show());
        }
      }, 300);
    },
    countchildren(node) {
      // let count = node.data.children.length
      let count = 0;
      node.data.children.forEach((child) => {
        count += this.count(child);
      });
      // console.log(count)
      return count;
    },
    count(node) {
      if (!node.children || node.children.length === 0) {
        return 1;
      }

      let leafCount = 0;
      node.children.forEach((child) => {
        leafCount += this.count(child);
      });

      return leafCount;
      // let count1 = node.children.length
      // node.children.forEach(child => {
      //   count1 += this.count(child)
      // })
      // return count1
    },
    isFinalChild(node) {
      // console.log(node)
      return (
        !node.childNodes ||
        (node.childNodes.length === 0 && node.data.label !== "Angiospermae")
      );
    },
    filterNode1(value, data, node) {
      if (!value) return true;
      let parentNode = node.parent;
      let labels = [node.label];
      let level = 1;
      while (level < node.level) {
        labels = [...labels, parentNode.label];
        parentNode = parentNode.parent;
        level++;
      }
      return labels.some((label) => label.indexOf(value) !== -1);
    },
    filterNode2(value, data, node) {
      if (!value) return true;
      let parentNode = node.parent;
      let labels = [node.label];
      let level = 1;
      while (level < node.level) {
        labels = [...labels, parentNode.label];
        parentNode = parentNode.parent;
        level++;
      }
      return labels.some((label) => label.indexOf(value) !== -1);
    },
    show1() {
      this.showall1 = !this.showall1;
      this.Showall1 = this.showall1 ? "Collapse" : "Show All";
      this.builddata1();
    },
    show2() {
      this.showall2 = !this.showall2;
      this.Showall2 = this.showall2 ? "Collapse" : "Show All";
      this.builddata2();
    },
    builddata1() {
      for (let i = 0; i < this.$refs.tree1.store._getAllNodes().length; i++) {
        this.$refs.tree1.store._getAllNodes()[i].expanded = this.showall1;
      }
    },
    builddata2() {
      for (let i = 0; i < this.$refs.tree2.store._getAllNodes().length; i++) {
        this.$refs.tree2.store._getAllNodes()[i].expanded = this.showall2;
      }
    },
    // mountClick() {
    //   this.$refs.hbTreeChart.myChart.off('click').on('click',
    //     (params) => {
    //       console.log(params)
    //       if (params.componentSubType == 'tree') {
    //         if (!('children' in params.data)) {
    //           this.$router.push({
    //             path: '/genome/' + params.name,
    //           })
    //         }
    //       }
    //     }
    //   )
    // },
    // getHbChartInfo() {
    //   getChartInfo().then(
    //     response => {
    //       //console.log(response)
    //       this.treeData = response.data.treeinfo
    //       this.barData = response.data.timeinfo
    //     }
    //   )
    // },
    resizeContainer() {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const containerWidth =
        windowWidth > 1920 ? windowWidth * 0.75 : windowWidth;
      this.polyWidth = containerWidth;
      if (containerWidth > windowHeight * 0.855) {
        this.chartContainerSize = windowHeight * 0.855;
      } else {
        this.chartContainerSize = containerWidth;
      }
    },
    // restoreChart() {
    //   this.treeOption = treeRadial(this.newTree.children)
    //   this.$refs.hbTreeChart.myChart.clear()
    //   this.$refs.hbTreeChart.myChart.setOption(this.treeOption)
    // },
    // depthChange(level) {
    //   this.treeOption.series[0].initialTreeDepth = level
    //   this.$refs.hbTreeChart.myChart.clear()
    //   this.$refs.hbTreeChart.myChart.setOption(this.treeOption)
    // },
    handleExpand_flower(node) {
      this.expandNextNonEmptyNode_flower(node);
    },
    expandNextNonEmptyNode_flower(node) {
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          if (child.label === "") {
            this.$refs.tree2.$set(
              this.$refs.tree2.store.nodesMap[child.id],
              "expanded",
              true
            );
            this.expandNextNonEmptyNode_flower(child);
          }
        });
      }
    },
    handleExpand(node) {
      this.expandNextNonEmptyNode(node);
    },
    expandNextNonEmptyNode(node) {
      if (node.children && node.children.length > 0) {
        // console.log(node.children)
        node.children.forEach((child) => {
          if (child.label === "") {
            // console.log(child)
            // console.log(this.$refs.tree.store.nodesMap)
            this.$refs.tree1.$set(
              this.$refs.tree1.store.nodesMap[child.id],
              "expanded",
              true
            );
            this.expandNextNonEmptyNode(child);
            // this.$refs.tree.store.nodesMap[child.id].expanded = true;
          }
        });
      }
    },
    // showTree() {
    //   this.showPoly = false
    //   this.treeOption = treeRadial(this.newTree.children)
    //   setTimeout(() => {
    //     this.mountClick()
    //   }, 300)
    // },
  },
};
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chart-header {
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
}
.chart-title {
  font-size: 30px;
  font-weight: bold;
  color: #2ca25f;
  font-family: Georgia, "Times New Roman", Times, serif;
}
.container {
  max-width: 100%; /* 根据需要调整宽度 */
  margin: 0 auto; /* 居中 */
}
.box {
  border: 1px solid #ebeef5;
  border-radius: 1px;
  padding: 50px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.tree-title {
  line-height: 88px;
  font-size: 2rem;
  font-weight: 800;
  color: #41ab5d;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
  position: absolute;
  opacity: 0 !important;
}

::v-deep .el-tree-node__content {
  position: relative;
}

.disabled {
  // cursor: not-allowed;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}

.hb-container {
  border: 0.2rem ridge #4292c6;
  border-radius: 15px;
}

.hb-header {
  text-align: center;
}

.statis-box .hb-jumbotron {
  margin-top: 20px;
  height: calc(27rem + 10vw);
}

#tree-container {
  text-align: center;

  .echarts-container {
    width: 100%;
    height: 100%;
    position: relative;

    i {
      font-size: 1.15rem;
      font-family: "Times New Roman", Times, serif;
      position: absolute;
      z-index: 10;
      left: 0;
      cursor: pointer;
      transition: all 0.25s ease;

      &:hover {
        color: #4292c6;
      }
    }
  }
}

.hb-jumbotron .jumbotron {
  background: url(@/assets/img/recent_release_bg.png);
  position: relative;
  // border-top: #D1CAC4 outset 1.55px;
  // border-right: #D1CAC4 outset 1.55px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // border-right: #D1CAC4 solid 1.5px;
  // background: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: right;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 70%;
    height: 1.75px;
    background-color: #d2ccc6;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 1.75px;
    height: 50%;
    background-color: #7d7975;
  }
}

.jumbotron {
  padding-top: 4rem;
  padding-right: 2rem;
  padding-bottom: 0rem;
  padding-left: 2rem;
}

.info-card {

  border-radius: 22px;

  background: #ffffff;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 0 10px rgba(0, 0, 0, 0.03);

  padding: 18px 22px;

  transition: all 0.25s ease;
}

.info-card:hover {
  transform: translateY(-2px);

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-title {
  font-size: 20px;

  font-weight: 700;

  color: #2f9d5d;

  margin-bottom: 14px;

  text-align: center;
}

.card-content {
  font-size: 14px;

  color: #444;

  line-height: 1.7;

  word-break: break-word;
}
</style>